import React from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { AppSVG } from "../../common/ImagePath";
import { RoutePaths } from "../../common/RoutePaths";
import { useLaunch } from "../../../auth/useAuth";

const GameBanner = ({ gameName, onRulesClick }) => {
  // const dispatch = useDispatch();
  // const status = useSelector((state) => state.gamesMeta.status);
  const gameMetaData = useSelector((state) => state.gamesMeta.data);
  const { launchParams } = useLaunch();
  const showBackButton = launchParams?.mockSession === true;

  // useEffect(() => {
  //   if (status === 'idle') {
  //     dispatch(fetchGameMeta());
  //   }
  // }, [status, dispatch]);

  const bannerImg = gameMetaData?.lobbyMeta?.[gameName]?.gameBackgroundImage;
  const isVideo = /\.mp4($|\?)/i.test(bannerImg ?? "");

  return (
    <div
      className="relative w-screen ml-[calc(50%-50vw)] aspect-video sm:w-full sm:ml-0 sm:aspect-auto sm:h-[250px] flex flex-col items-center justify-center mb-8 sm:rounded-app overflow-hidden">

      {isVideo ? (
        <>
          {/* Blurred background fill — same video, covers the box and fills the
              pillarbox gaps on desktop where the foreground keeps its aspect ratio */}
          <video
            aria-hidden="true"
            src={bannerImg}
            autoPlay
            muted
            loop
            playsInline
            className="absolute inset-0 w-full h-full object-cover scale-110 blur-xl"
          />

          {/* Foreground banner — full-bleed cover on mobile, true aspect ratio
              (contain) centered on desktop */}
          <video
            src={bannerImg}
            autoPlay
            muted
            loop
            playsInline
            className="absolute inset-0 w-full h-full object-cover sm:object-contain"
          />
        </>
      ) : (
        <>
          {/* Blurred background fill — same image, covers the box and fills the pillarbox
              gaps on desktop where the foreground image keeps its true aspect ratio */}
          <div
            aria-hidden="true"
            className="absolute inset-0 bg-center bg-cover scale-110 blur-xl"
            style={{ backgroundImage: `url(${bannerImg})` }}
          />

          {/* Foreground banner — full-bleed cover on mobile, true aspect ratio (contain)
              centered on desktop */}
          <div
            className="absolute inset-0 bg-center bg-no-repeat bg-cover sm:bg-contain"
            style={{ backgroundImage: `url(${bannerImg})` }}
          />
        </>
      )}

      <div className={`absolute top-4 left-4 right-4 flex ${showBackButton ? "justify-between" : "justify-end"} z-20`}>
        {showBackButton && (
          <Link
            to={RoutePaths.HOME}
            className="p-[9px] flex items-center justify-center rounded-full bg-gradient-to-b from-blackShade3 to-blackShade2 backdrop-blur-md transition-all active:scale-95"
          >
            <ArrowLeft className="w-3 h-3 sm:w-5 sm:h-5" />
          </Link>
        )}

        <button
          onClick={onRulesClick}
          className="py-[9px] px-[9px] flex items-center justify-center rounded-full bg-gradient-to-b from-blackShade3 to-blackShade2 backdrop-blur-md transition-all active:scale-95"
        >
          <img src={AppSVG.questionmark} className="h-3 w-3 sm:h-5 sm:w-5" alt="questionmark" />
        </button>
      </div>
    </div>
  );
};

export default GameBanner;
